import { connect } from 'react-redux';

import { Dispatch, IAppState } from '../../../../../../../common/state';
import { wordIncludeAdded, wordIncludeRemoved } from '../../../../../../state/advanced/words_include';

import { WordsInclude as WordsIncludeComponent } from './wordsInclude';

export const mapStateToProps = (state: IAppState) => ({
  wordsInclude:
    (state.filters.jsonQuery.description_include && state.filters.jsonQuery.description_include.value) || [],
  isModerator: state.user.isAuthenticated && state.user.isModerator,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onWordIncludeAdded: (word: string) => {
    dispatch(wordIncludeAdded(word));
  },
  onWordIncludeRemoved: (word: string) => {
    dispatch(wordIncludeRemoved(word));
  },
});

export const WordsInclude = connect(mapStateToProps, mapDispatchToProps)(WordsIncludeComponent);
